import * as React from 'react';
import { mutatorAction } from 'satcheljs';
import { observer } from 'mobx-react-lite';
import { useWindowEvent } from 'owa-react-hooks/lib/useWindowEvent';
import { useSurfaceStore } from './StoreContextProvider';
import type SurfaceStore from '../interfaces/SurfaceStore';

export default observer(function MonthItemsPanel({
    children,
    className,
    handlers,
}: {
    children?: React.ReactNode;
    handlers?: React.DOMAttributes<HTMLElement>;
    className?: string;
} & React.DOMAttributes<HTMLDivElement>) {
    const ref = React.useRef<HTMLDivElement>();
    const store = useSurfaceStore();
    const onResize = React.useCallback(() => {
        updateMonthHeight(store, ref.current.clientHeight);
    }, [ref, store]);

    React.useEffect(onResize);
    useWindowEvent('resize', onResize, [onResize]);

    return (
        <div ref={ref} className={className} {...handlers}>
            {children}
        </div>
    );
});

const updateMonthHeight = mutatorAction(
    'updateMonthHeight',
    (store: SurfaceStore, newValue: number) => {
        store.monthHeight = newValue;
    }
);
